export function constant(x) {
    return function () {
        return x;
    };
}
//# sourceMappingURL=constant.js.map